import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import ImageUploader from 'react-images-upload';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import queryString from 'query-string';
import { withRouter } from 'react-router';
import { getImageUrls } from '../../utils/files';
import './styles/editUserBenefit.scss';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedEditUserBenefit(props) {

  const values = queryString.parse(props.location.search);
  const benefitId = values.id;

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [benefitName, setBenefitName] = useState('');
  const [description, setDescription] = useState('');
  const [details, setDetails] = useState('');
  const [serverPhotos, setServerPhotos] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [photoFiles, setPhotoFiles] = useState([]);
  const [validated, setValidated] = useState(false);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (updated) {
      alert('Ayuda actualizada.');
      props.history.push('/dashboard/seccion_solidaria');
    }
  }, [updated]);

  const getData = async () => {
    setLoading(true);

    const benefitProm = await fetch(`${apiUrl}/benefits/get/${benefitId}`);
    const benefitResp = await benefitProm.json();

    if (benefitResp.success) {
      const { benefit } = benefitResp;

      setBenefitName(benefit.name);
      setDescription(benefit.description);
      setDetails(benefit.details);
      setPhotos(benefit.photos);
      setServerPhotos(benefit.photos);
    }

    setLoading(false);
  };

  const onDrop = (pictureFiles, pictureDataURLs) => {
    setServerPhotos(serverPhotos.filter(item => pictureDataURLs.includes(item)));
    setPhotos(pictureDataURLs);
    setPhotoFiles(pictureFiles);
  };

  const handleSubmit = async event => {

    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {
      setUpdating(true);

      const photosArrayResp = await getImageUrls(photoFiles);

      if (!photosArrayResp.success) {
        alert('Error al editar la ayuda. Inténtalo nuevamente.');
      } else {

        const photosArray = serverPhotos.concat(photosArrayResp.urlArray);

        if (photosArray.length === 0) {
          setUpdating(false);
          return alert('Debes subir por lo menos una imagen.');
        }

        const updateProm = await fetch(`${apiUrl}/benefits/update`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            token: props.token,
            userId: props.userId,
            businessName,
            benefitId,
            name: benefitName,
            description,
            details,
            thumbnail: photosArray[0],
            photos: photosArray
          })
        });

        const updateResp = await updateProm.json();

        if (updateResp.success) setUpdated(true);
        else alert(updateResp.message || 'Error al editar la ayuda. Inténtalo nuevamente.');
      }

      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="edit-user-benefit-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="edit-user-benefit-component">
      <Container>
        <Row>
          <Col>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Row>
                <Form.Group as={Col} md={8}>
                  <Form.Label className="app-label">Título de la ayuda</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Título de la ayuda"
                    value={benefitName}
                    onChange={event => setBenefitName(event.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} md={12}>
                  <Form.Label className="app-label">Descripción</Form.Label>
                  <Form.Control
                    type="text"
                    as="textarea"
                    rows="3"
                    placeholder="Describe la ayuda"
                    value={description}
                    onChange={event => setDescription(event.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} md={12}>
                  <Form.Label className="app-label">Detalles (opcional)</Form.Label>
                  <Form.Control
                    type="text"
                    as="textarea"
                    rows="3"
                    placeholder="Detalles adicionales de la ayuda"
                    value={details}
                    onChange={event => setDetails(event.target.value)}
                  />
                </Form.Group>
                <Form.Group as={Col} md={12}>
                  <Form.Label className="app-label">Subir fotos de la ayuda</Form.Label>
                  <ImageUploader
                    className="multImageInput"
                    withIcon={false}
                    withPreview={true}
                    fileContainerStyle={{ borderRadius: '5px', borderStyle: 'solid', borderColor: 'lightgray', borderWidth: 'thin' }}
                    buttonText='Escoge una o varias imágenes'
                    label='Tamaño máximo por imagen: 5mb, formatos: jpg, gif, png'
                    onChange={onDrop}
                    imgExtension={['.jpeg', '.jpg', '.gif', '.png', '.gif']}
                    maxFileSize={5242880}
                    fileSizeError='Archivo demasiado grande. Máximo 5mb.'
                    fileTypeError='Extension del archivo no soportado.'
                    defaultImages={photos}
                  />
                </Form.Group>

                <Button type="submit" className="app-button center" disabled={updating}>
                  {
                    updating ? <Spinner animation="border" variant="warning" size="sm" /> : 'Actualizar'
                  }
                </Button>

              </Form.Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );

}

const EditUserBenefit = connect(select)(ConnectedEditUserBenefit);

export default withRouter(EditUserBenefit);
